import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import styles from './LandingSelector.module.css';
import humanIcon from '../../assets/img/brand/human-genetics-icon.jpg';
import animalIcon from '../../assets/img/brand/animal-genetics-icon.jpg';
import igisekuruzaIcon from '../../assets/img/brand/igisekuruza-icon.jpg';

interface ServiceOption {
  key: string;
  to: string;
  icon: string;
  title: string;
  description: string;
  accent: string;
  accentSoft: string;
}

const SERVICES: ServiceOption[] = [
  {
    key: 'human',
    to: '/human-genetics',
    icon: humanIcon,
    title: 'Human Genetics',
    description: 'Genomic solutions for healthier people and stronger communities.',
    accent: '#3a7bf5',
    accentSoft: 'rgba(58, 123, 245, 0.12)',
  },
  {
    key: 'animal',
    to: '/animal-genetics',
    icon: animalIcon,
    title: 'Animal Genetics',
    description: 'Genomic insights for healthier livestock, higher productivity and a stronger agricultural future.',
    accent: '#1f9d5a',
    accentSoft: 'rgba(31, 157, 90, 0.12)',
  },
  {
    key: 'igisekuruza',
    to: '/igisekuruza',
    icon: igisekuruzaIcon,
    title: 'iGiSEKURUZA',
    description: 'Preserving our family trees, our heritage and our identity for future generations.',
    accent: '#b4690e',
    accentSoft: 'rgba(180, 105, 14, 0.12)',
  },
];

const LandingSelector: React.FC = () => {
  return (
    <div className={styles.page}>
      <div className={styles.bgGlow} aria-hidden />

      <header className={styles.topbar}>
        <Link to="/" className={styles.brand} aria-label="iGiTREE home">
          <span className={styles.brandDark}>i</span>
          <span className={styles.brandAccent}>Gi</span>
          <span className={styles.brandDark}>TREE</span>
        </Link>
      </header>

      <main className={styles.main}>
        <p className={styles.eyebrow}>WELCOME TO iGiTREE</p>
        <h1 className={styles.heading}>
          What are you <span className={styles.headingAccent}>looking for?</span>
        </h1>
        <p className={styles.subtitle}>CHOOSE YOUR iGiTREE EXPERIENCE</p>

        <div className={styles.cards}>
          {SERVICES.map((service, index) => (
            <Link
              key={service.key}
              to={service.to}
              className={styles.card}
              style={
                {
                  '--accent': service.accent,
                  '--accent-soft': service.accentSoft,
                  animationDelay: `${index * 0.12}s`,
                } as React.CSSProperties
              }
            >
              <span className={styles.iconCircle}>
                <img src={service.icon} alt="" className={styles.iconImg} />
              </span>
              <h2 className={styles.cardTitle}>{service.title}</h2>
              <p className={styles.cardDesc}>{service.description}</p>
              <span className={styles.arrowBtn} aria-hidden>
                <ArrowRight size={18} strokeWidth={2.25} />
              </span>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default LandingSelector;
